declare namespace $ {

	type $mol_labeler__title_bog_gamengine_demo_crumb_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_crumb_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gamengine_demo_crumb_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_crumb_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_crumb_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_crumb_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_crumb_7 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_crumb_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $mol_view__sub_bog_gamengine_demo_crumb_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_gamengine_demo_crumb_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_gamengine_demo_crumb_11 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['restart'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_page__title_bog_gamengine_demo_crumb_12 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['end_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_gamengine_demo_crumb_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_demo_crumb_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_view__sub_bog_gamengine_demo_crumb_15 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['field'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_crumb_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gamengine_phys__bodies_bog_gamengine_demo_crumb_17 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['bodies'] >
		,
		ReturnType< $bog_gamengine_phys['bodies'] >
	>
	type $bog_gamengine_phys__tile_bog_gamengine_demo_crumb_18 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Tile'] >
		,
		ReturnType< $bog_gamengine_phys['tile'] >
	>
	type $bog_gamengine_phys_tile__map_bog_gamengine_demo_crumb_19 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['map'] >
		,
		ReturnType< $bog_gamengine_phys_tile['map'] >
	>
	type $bog_gamengine_phys_tile__solid_bog_gamengine_demo_crumb_20 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys_tile['solid'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_crumb_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_crumb_22 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_clock__paused_bog_gamengine_demo_crumb_23 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['paused'] >
		,
		ReturnType< $bog_gamengine_clock['paused'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_demo_crumb_24 = $mol_type_enforce<
		({ 
			'left': readonly(any)[],
			'right': readonly(any)[],
			'up': readonly(any)[],
			'down': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_input__key_bog_gamengine_demo_crumb_25 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_cam_flat__height_bog_gamengine_demo_crumb_26 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['height'] >
	>
	type $bog_gamengine_cam_flat__pos_bog_gamengine_demo_crumb_27 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['cam_pos'] >
		,
		ReturnType< $bog_gamengine_cam_flat['pos'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_crumb_28 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__input_bog_gamengine_demo_crumb_29 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Input'] >
		,
		ReturnType< $bog_gamengine_scene['input'] >
	>
	type $bog_gamengine_scene__cam_bog_gamengine_demo_crumb_30 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Cam'] >
		,
		ReturnType< $bog_gamengine_scene['cam'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_crumb_31 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['nodes'] >
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__phys_bog_gamengine_demo_crumb_32 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Phys'] >
		,
		ReturnType< $bog_gamengine_scene['phys'] >
	>
	type $bog_gamengine_tilemap__tile_bog_gamengine_demo_crumb_33 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Tile'] >
		,
		ReturnType< $bog_gamengine_tilemap['tile'] >
	>
	type $bog_gamengine_tilemap__atlas_bog_gamengine_demo_crumb_34 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Atlas'] >
		,
		ReturnType< $bog_gamengine_tilemap['atlas'] >
	>
	type $bog_gamengine_tilemap__palette_bog_gamengine_demo_crumb_35 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['palette'] >
		,
		ReturnType< $bog_gamengine_tilemap['palette'] >
	>
	type $bog_gamengine_demo_crumb_hero__input_bog_gamengine_demo_crumb_36 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Input'] >
		,
		ReturnType< $bog_gamengine_demo_crumb_hero['input'] >
	>
	type $bog_gamengine_demo_crumb_hero__pos_bog_gamengine_demo_crumb_37 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['hero_pos'] >
		,
		ReturnType< $bog_gamengine_demo_crumb_hero['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_crumb_38 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Hero'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb_39 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb_40 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__size_bog_gamengine_demo_crumb_41 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['hero_size'] >
		,
		ReturnType< $bog_gamengine_sprite['size'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb_42 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb_43 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_crumb_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['crumb_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__size_bog_gamengine_demo_crumb_45 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['crumb_size'] >
		,
		ReturnType< $bog_gamengine_sprite['size'] >
	>
	type $bog_gamengine_demo_crumb_rule__hero_bog_gamengine_demo_crumb_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['Hero'] >
		,
		ReturnType< $bog_gamengine_demo_crumb_rule['hero'] >
	>
	type $bog_gamengine_demo_crumb_rule__crumbs_bog_gamengine_demo_crumb_47 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb['crumbs'] >
		,
		ReturnType< $bog_gamengine_demo_crumb_rule['crumbs'] >
	>
	type $bog_gamengine_demo_crumb_rule__limit_bog_gamengine_demo_crumb_48 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_crumb_rule['limit'] >
	>
	export class $bog_gamengine_demo_crumb extends $mol_page {
		left_str( ): string
		Left_label( ): $mol_labeler
		time_str( ): string
		Time_label( ): $mol_labeler
		paused( ): boolean
		Pause_switch( ): $mol_check_box
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_crumb['Draw'] >['stat'] >
		Draw( ): $bog_gamengine_draw
		end_title( ): string
		end_hint( ): string
		End_hint( ): $mol_view
		restart( next?: any ): any
		Again( ): $mol_button_major
		End( ): $mol_page
		field( ): readonly(any)[]
		Field( ): $mol_view
		Stat( ): $mol_view
		cam_pos( ): Float32Array
		nodes( ): readonly(any)[]
		bodies( ): readonly(any)[]
		Phys( ): $bog_gamengine_phys
		palette( ): Record<string, any>
		hero_pos( next?: Float32Array ): Float32Array
		hero_size( ): Float32Array
		crumb_pos( id: any): Float32Array
		crumb_size( ): Float32Array
		crumbs( ): readonly(any)[]
		title( ): string
		key_map( ): Record<string, any>
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		map( ): string
		Tile( ): $bog_gamengine_phys_tile
		Atlas( ): $bog_gamengine_atlas
		Clock( ): $bog_gamengine_clock
		Key( ): $bog_gamengine_key
		Input( ): $bog_gamengine_input
		Cam( ): $bog_gamengine_cam_flat
		Scene( ): $bog_gamengine_scene
		Tilemap( ): $bog_gamengine_tilemap
		Hero( ): $bog_gamengine_demo_crumb_hero
		Hero_sprite( ): $bog_gamengine_sprite
		Crumb( id: any): $bog_gamengine_sprite
		Rule( ): $bog_gamengine_demo_crumb_rule
	}
	
}

//# sourceMappingURL=crumb.view.tree.d.ts.map